import classnames from 'classnames';
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '@common/components/avatar';
import * as calendarHelpers from '@common/brzw_calendar/helpers';
import { addFlyout, FLYOUT_TYPES } from '@common/utils/flyout';
import { getTaskSeriesId } from '@common/utils/task';
import { SingleTask } from '@common/brzw_calendar/commons';
import { personName } from '@common/utils/people_helpers';
import CommentSkeleton from '../../skeletons/comment_skeleton';

import './last_comment_cell.scss';

const CLASS_NAME = 'last-comment-cell';

const LastCommentCell = (props, customProps) => {
  const lastComment = _.get(props, 'last_comment');
  const lastCommentId = _.get(props, 'last_comment.id');
  const readyStatus = _.get(props, 'ready_status.type_property_ready_status');
  const defaultCell = _.get(customProps, 'defaultCell');
  const withSkeletons = _.get(customProps, 'withSkeletons');
  const withLink = _.get(customProps, 'withLink');
  const withTask = _.get(customProps, 'withTask');
  const withAvatar = _.get(customProps, 'withAvatar');

  const task = _.get(lastComment, 'task');
  const taskId = _.get(lastComment, 'task.id');
  const taskDraftId = getTaskSeriesId(task);
  const taskName = _.get(task, 'name');
  const commentName = _.get(lastComment, 'text');
  const author = _.get(lastComment, 'author');
  const personIsUnassigned = _.get(author, 'id') === 'unassigned';

  if (withSkeletons && _.isUndefined(lastComment)) {
    return <CommentSkeleton />;
  }

  if (_.isEmpty(_.keys(lastComment))) {
    return <div className="default-cell--empty"> - </div>;
  }

  let taskProps = task && calendarHelpers.getSingleTaskProps(task);
  taskProps = _.omit(taskProps, 'onTaskClick');
  const tooltipSettings = {
    containerHeight: window.innerHeight,
    containerWidth: window.outerWidth,
    paddingHorizontalRemoval: 4,
    paddingVerticalRemoval: 16,
  };

  const taskComponent = withTask && task && (
    <SingleTask
      readyStatus={readyStatus}
      tooltipSettings={tooltipSettings}
      withText={false}
      withToolTip
      {...taskProps}
    />
  );

  const userComponent = withAvatar && (
    <Avatar title={personName(author)} person={personIsUnassigned ? null : author} />
  );

  const content = (
    <>
      <div className={`${CLASS_NAME}__title`}>{taskName}</div>
      <div className={`${CLASS_NAME}__comment`}>{commentName}</div>
    </>
  );

  if (withLink) {
    const goToTaskComment = () => {
      if (!_.isNull(taskId)) {
        addFlyout(FLYOUT_TYPES.TASK_EDIT, { taskId, hiddenScroll: 'comment', lastCommentId });
      } else if (!_.isNull(taskDraftId)) {
        addFlyout(FLYOUT_TYPES.TASK_DRAFT_EDIT, {
          hiddenScroll: 'comment',
          lastCommentId,
          taskDraftId,
        });
      }
    };

    return (
      <div className={classnames(CLASS_NAME, { 'default-cell': defaultCell })}>
        {userComponent}
        {taskComponent}
        <div
          className={`${CLASS_NAME}__title-container ${CLASS_NAME}--link`}
          role="presentation"
          onClick={goToTaskComment}
        >
          {content}
        </div>
      </div>
    );
  }

  return (
    <div className={classnames(CLASS_NAME, { 'default-cell': defaultCell })}>
      {taskComponent}
      <div className={`${CLASS_NAME}__title-container`}>{content}</div>
    </div>
  );
};

LastCommentCell.propTypes = {
  created_at: PropTypes.string,
  task: PropTypes.shape({
    name: PropTypes.string,
  }),
  text: PropTypes.string,
};

export default LastCommentCell;
